module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Rafael_Nikita.639b79d2.jpg";